import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { FrontendField } from 'src/modules/sm-base/netgen/FrontendField';
import { FrontendFieldType } from 'src/modules/sm-base/netgen/FrontendFieldType';
import { FrontendForm } from 'src/modules/sm-base/netgen/FrontendForm';
import { EnaioCertificateService } from '../../services/enaio-certificate.service';
import { GlobalSettings } from '../../shared/global-settings.entity';

@Component({
    selector: 'app-global-settings',
    templateUrl: './global-settings.component.html',
    styleUrls: ['./global-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GlobalSettingsComponent extends ComponentView {

    service = inject(EnaioCertificateService);

    globalSettings: GlobalSettings = null;
    form: FrontendForm;

    async initParams(): Promise<boolean> {
        this.fullScreenComponent = false;
        this.globalSettings = await RestEndpoint.main().find().run("api/cer/globalsettings").get(GlobalSettings);

        this.form = new FrontendForm([
            new FrontendField("editingAllowed", "Bearbeiten von Zeugnissen und Noten erlauben", FrontendFieldType.bool),
            new FrontendField("dateOfHalfYearCertificate", "Datum des Halbjahreszeugnisses", FrontendFieldType.date),
            new FrontendField("dateOfFullCertificate", "Datum des Endjahreszeugnisses", FrontendFieldType.date),
            new FrontendField("dateOfSemesterEnd", "Ende des ersten Semesters", FrontendFieldType.date)
        ]);
        this.form.fill(this.globalSettings);

        this.app.updateNavigation("Administration", [
            this.service.getHomeCertificates(),
            { label: "Administration", routerLink: ["/enaio-certificates/globalsettings"] }
        ]);

        return true;
    }

    async save(): Promise<void> {
        if (!this.app.validateForm(this.form)) {
            return;
        }
        this.form.get(this.globalSettings);
        await this.app.saveDataHandler(async () => RestEndpoint.main().upsert(this.globalSettings).run("api/cer/globalsettings").getText(), this, true, true);
    }

}
